/** URL paths for the trilingual hidden job market / networking article — March 2026 (no trailing slash). */
export const HIDDEN_JOB_MARKET_NETWORKING_202603_URL_PATHS = {
  en: '/en/resources/jobs-in-finland/finland-hidden-job-market-networking-2026-03',
  fi: '/fi/tyoelama/tyot-suomessa/suomen-piilotyomarkkinat-verkostoituminen-2026-03',
  sv: '/sv/arbetsliv/jobb-i-finland/finlands-dolda-arbetsmarknad-2026-03',
} as const;

export type HiddenJobMarketNetworking202603Locale = keyof typeof HIDDEN_JOB_MARKET_NETWORKING_202603_URL_PATHS;
